import { AppContext } from '@utils/browser/app-context';
import React, { useContext, FC } from 'react';
import FollowGuideMobile from './mobile';
import FollowGuidePC from './pc';
import type { IProps } from './logic';

const FollowGuide: FC<IProps> = (props) => {
  const { isMobile } = useContext(AppContext);
  if (typeof isMobile === 'undefined') return null;
  if (isMobile) {
    return <FollowGuideMobile {...props} />;
  }
  return <FollowGuidePC {...props} />;
};

FollowGuide.displayName = 'FollowGuide';

export default FollowGuide;
